import { ChecklistModel } from '@akin-home/checklists';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { useUpdateFieldsCommand } from '../../chat/hooks';

export const useUpdateChecklistFormCommand = (
  update:
    | Dispatch<SetStateAction<ChecklistModel>>
    | Dispatch<SetStateAction<ChecklistModel | undefined>>
) =>
  useUpdateFieldsCommand(
    useCallback(
      (data: any) => {
        update((checklist) => ({ ...checklist, ...data }));
      },
      [update]
    )
  );
